// extracted by mini-css-extract-plugin
module.exports = {"container":"DashboardHeader_container__2tvR3","btn":"DashboardHeader_btn__AIBTC","text":"DashboardHeader_text__3exi2","small":"DashboardHeader_small__3fB9g"};